export function AdminField({ id, label, value, onChange, multiline = false, placeholder = "" }) {
  const Component = multiline ? "textarea" : "input";

  return (
    <label className="admin-field" data-testid={`${id}-field`}>
      <span data-testid={`${id}-label`}>{label}</span>
      <Component
        value={value || ""}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
        data-testid={`${id}-input`}
      />
    </label>
  );
}

export function AdminListField({ id, label, values = [], onChange, placeholder = "One item per line" }) {
  return (
    <AdminField
      id={id}
      label={label}
      value={(values || []).join("\n")}
      placeholder={placeholder}
      multiline
      onChange={(text) => onChange(text.split("\n").map((item) => item.trim()).filter(Boolean))}
    />
  );
}

export function AdminSection({ title, eyebrow, children }) {
  return (
    <section className="admin-form-section" data-testid={`admin-section-${title.toLowerCase().replaceAll(" ", "-")}`}>
      <div className="admin-form-section-heading">
        <p className="overline" data-testid={`admin-section-${title.toLowerCase().replaceAll(" ", "-")}-eyebrow`}>{eyebrow}</p>
        <h2 data-testid={`admin-section-${title.toLowerCase().replaceAll(" ", "-")}-title`}>{title}</h2>
      </div>
      <div className="admin-form-grid" data-testid={`admin-section-${title.toLowerCase().replaceAll(" ", "-")}-fields`}>
        {children}
      </div>
    </section>
  );
}